import { render } from "./TBtn.vue?vue&type=template&id=cf3df24e"
import script from "./TBtn.vue?vue&type=script&lang=js"
export * from "./TBtn.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__